"use strict";

import React from 'react';

function MainNavListItemContent(props) {
    const {content='', description='', className='account__main-navigation__nav__list-item'} = props;
    return (
        <React.Fragment>
            <span className={`${className}__link__content`}>{content}</span>
            <span className={`${className}__link__description`}>{description}</span>
        </React.Fragment>
    );
}

export default MainNavListItemContent;